import React from "react";
import { connect } from "react-redux";
import { Grid, Typography, Button } from "material-ui";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { register, tupasLogin } from "../../ducks/user";
import {
    RouterProps,
    RouteProps,
    Redirect,
    RouteComponentProps,
} from "react-router";
import logger from "../../util/logger";
import logo from "../../images/hypo-logo-complete-blue.svg";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";
import { Link } from "react-router-dom";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";

const styles = {
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: 0,
        marginRight: -12,
    },
};

interface ITLoginPageProps
    extends RouteComponentProps<{ verificationHash: string }> {}
interface ITLoginPageReduxProps {
    loading: boolean;
}
interface ITLoginPageDispatchProps {
    login: (verificationHash: string) => Promise<void>;
    setHeaderValue: (header: string) => void;

    setBackButton: (route: string) => void;
    hideBackButton: () => void;
}

type TupasLoginPageProps = ITLoginPageProps &
    ITLoginPageReduxProps &
    ITLoginPageDispatchProps &
    RouterProps;

export class TupasLoginPage extends React.Component<TupasLoginPageProps, {}> {
    constructor(props: TupasLoginPageProps) {
        super(props);
    }
    componentDidMount() {
        this.props.hideBackButton();
        this.props.setHeaderValue("");
        let verification = this.props.match.params.verificationHash;
        if (verification) {
            this.props
                .login(verification)
                .then(() => this.props.history.replace("/"))
                .catch((e) => logger.error(e));
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeaderValue("");
    }

    render() {
        if (!this.props.match.params.verificationHash) {
            return <Redirect to="/tupas/verification/2" />;
        }
        return (
            <div className="LoginPage_Container container-with-logo">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <FullPageSpinner loading={this.props.loading} />
                    {!this.props.loading && (
                        <Grid container justify="center">
                            <Grid item xs={12} sm={10} md={6}>
                                <Typography
                                    variant="title"
                                    color="inherit"
                                    style={styles.flex}
                                >
                                    <img className={"loginLogo"} src={logo} />
                                    <div></div>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography style={{ textAlign: "center" }}>
                                    Varmennus epäonnistui. Ole hyvä ja yritä
                                    myöhemmin uudelleen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} alignContent="center">
                                <Link className={"bluelink"} to={"/login"}>
                                    <h4 className={"loginHeader"}>
                                        Palaa takaisin
                                    </h4>
                                </Link>
                            </Grid>
                        </Grid>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): ITLoginPageReduxProps => {
    return {
        loading: state.user.loading,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ITLoginPageDispatchProps => {
    return {
        login: async (verificationHash: string) => {
            await dispatch(tupasLogin(verificationHash));
        },
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect<
    ITLoginPageReduxProps,
    ITLoginPageDispatchProps,
    ITLoginPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(TupasLoginPage);



// WEBPACK FOOTER //
// ./src/views/login/TupasLogin.tsx